module.exports = __webpack_public_path__ + "img/liucheng3.5cdfe152.png";